export default __webpack_public_path__ + "static/media/GeorgeMad.1b210a2f.jpg";